import React, { useState, useEffect } from "react"
import {useParams} from "react-router-dom"
import Swal from "sweetalert2"
import EditProduct from "./forms/EditProduct"
import {URL} from "../config"


const Product = ({user, token}) => {
  // console.log(user)

  let {id} = useParams()
  const [product, setProduct] = useState({})
  const [editing, setEditing] = useState(false)

  useEffect(()=>{
    fetch(`${URL}/products/${id}`)
    .then(res=>res.json())
    .then(data=>{
      // console.log(data)
      setProduct(data)
    })
  }, [id])


  const deleteHandler = () => {
    Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes'
  })
  .then((result) => {
    if (result.value) {
          fetch(`${URL}/products/${id}`, {
            method: "DELETE",
            headers : {
              "x-auth-token": token
            }
          })
          .then(res => res.json())
          .then(data => {
      Swal.fire(
        'Deleted!',
        'Your file has been deleted.',
        'success'
      )
      window.location.href="/" 
        })
      }
    })
  }

  return(
    <div className="product-background">
      <div className="container pt-5 pb-5">

      { editing ? <EditProduct product={product} setEditing={setEditing} token={token} /> :
        <div className="row">
          <div className="col-md-5 mx-auto">

            <h3 className="mb-5">Tour Details</h3>
            <div className="card">
              <div>
                <div className="card-header">
                  <h5>{product.name}</h5>
                </div>
                <div className="card-body">
                  <img src={`${URL}/${product.image}`} alt="product" className="img-fluid"/>
                  <p>{product.description}</p>
                  <h6>PHP {product.price}</h6>

                  { user && token && user.isAdmin ?
                  <div className="card-footer text-center">
                    <button className="btn btn-primary mr-1" onClick={() => setEditing(true)}>Edit</button>
                    <button className="btn btn-danger ml-1" onClick={deleteHandler}>Delete</button>
                  </div> : null }
                </div>
              </div>
            </div>
          </div>
        </div> }
      </div>
    </div>
  )
}

export default Product